import { render } from "./TSN.vue?vue&type=template&id=d73a2e36&scoped=true"
import script from "./TSN.vue?vue&type=script&lang=js"
export * from "./TSN.vue?vue&type=script&lang=js"

import "./TSN.vue?vue&type=style&index=0&id=d73a2e36&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d73a2e36"]])

export default __exports__